import React from 'react';
import { unescape } from 'lodash';

import style from '../index.module.css';

import Placeholder from '../../../static/images/placeholder.svg';

type LotCardProps = {
    artists?: Array<string>;
    details?: string;
    endDate?: number;
    image?: string;
    imageAltText?: string;
    promoType: string;
    title?: string;
    url?: string;
    available?: boolean;
};

const LotCard = ({ artists, details, image, imageAltText, promoType, title, url, available }: LotCardProps) => {
    if (details?.indexOf('|') > -1) {
        details = details.replace(' | ', '\n');
    } else if (details) {
        details = details.replace(': ', ':\n');
    }

    return (
        <div className={style.cardPromo} data-type={promoType}>
            <div className={style.imageContainer}>
                {/* Remove tabindex so users don't have to tab through cards twice (they are both the same link) */}
                <a href={url} tabIndex={-1}>
                    <img src={image ? image : Placeholder} alt={imageAltText ? imageAltText : unescape(title)} />
                </a>
            </div>

            <div className="info">
                <a href={url}>
                    {artists?.length > 0 && (
                        <div className={`${style.creator} ${style.oneLineClamp}`}>{unescape(artists.join(', '))}</div>
                    )}
                    <h3 className={`${style.title} ${artists?.length > 0 ? style.twoLineClamp : style.threeLineClamp}`}>
                        {unescape(title)}
                    </h3>

                    {details && <div className={`${style.estimate} ${style.wrapped}`}>{details}</div>}

                    {available && !details && <div className={style.estimate}>Estimate upon request</div>}

                    <div className={style.cta}>{available ? 'Bid now' : 'Past lot'}</div>
                </a>
            </div>
        </div>
    );
};

export default LotCard;
